/* ==========================================================================
   SearcherFlightHotelRxjs > Client > Config
   ========================================================================== */

/* Config */
const config = {
    component: 'SearcherFlightHotelRxjs',
    init: true,
    start: true,
    sameDay: false,
    css: {
        item: 'searcher__item',
        visible: 'is-visible',
        disabled: 'is-disabled',
        inputOrigin: 'searcher__item--origin',
        inputDestination: 'searcher__item--destination',
        inputCalendar: 'searcher__item--calendar',
        calendarPanel: 'input-panel__panel--calendar-svh',
        calendarFp: 'calendar-rxjs--single',
        inputAccommodation: 'searcher__item--accommodation',
        inputClasses: 'searcher__item--classes',
        panelCalendar: 'input-panel--calendar-svh',
        panelAccommodation: 'input-panel--accommodation-svh',
        panelClasses: 'input-panel--classes-svh',
        discounts: 'searcher__item--discounts',
        button: 'searcher__button',
        loading: 'loading-information-rxjs--svh'
    },
    type: {
        panel: 'ui-panel',
        origin: 'searcher-flight-hotel-origin',
        destination: 'searcher-flight-hotel-destination',
        calendar: 'searcher-flight-hotel-calendar',
        rooms: 'searcher-flight-hotel-rooms',
        addRoom: 'searcher-flight-hotel-add-rom',
        loading: 'searcher-flight-hotel-loading',
        discounts: 'searcher-flight-hotel-discounts',
        classes: 'searcher-flight-hotel-classes',
        submit: 'searcher-flight-hotel-submit'
    },
    hooks: {
        panelContent: 'data-searcher-flight-hotel-panel-content',
        panelBody: 'data-searcher-flight-hotel-panel-body'
    },
    onModal: false,
    showLoading: true
};

module.exports = () => config;
